/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CarDTO } from '../models/CarDTO';
import type { PageCarDTO } from '../models/PageCarDTO';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CustomCarResourceService {
    /**
     * @returns CarDTO OK
     * @throws ApiError
     */
    public static createCarOffer({
        requestBody,
    }: {
        requestBody: CarDTO,
    }): CancelablePromise<CarDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/custom/car/addOffer',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get the car dto requested
     * Retrieves the car dto requested
     * @returns CarDTO OK
     * @throws ApiError
     */
    public static getOffer({
        carId,
    }: {
        /**
         * The id of the car requested
         */
        carId: number,
    }): CancelablePromise<CarDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/custom/car/{carId}',
            path: {
                'carId': carId,
            },
        });
    }
    /**
     * Partial update of an existing car
     * Partial updates given fields of an existing car
     * @returns CarDTO OK
     * @throws ApiError
     */
    public static partialUpdateOffer({
        carId,
        requestBody,
    }: {
        /**
         * The id of the car requested
         */
        carId: number,
        requestBody: CarDTO,
    }): CancelablePromise<CarDTO> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/custom/car/{carId}',
            path: {
                'carId': carId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get a paginated list of all offers
     * Retrieves a paginated list of all cars to display in the catalog
     * @returns PageCarDTO OK
     * @throws ApiError
     */
    public static getAllOffers({
        page,
        size = 10,
        sortBy = 'brand',
        sortDir = 'asc',
    }: {
        /**
         * The page number for pagination
         */
        page?: number,
        /**
         * The number of items page for pagination
         */
        size?: number,
        /**
         * The field to sort the results by
         */
        sortBy?: string,
        /**
         * The sorting direction
         */
        sortDir?: string,
    }): CancelablePromise<PageCarDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/custom/car/whole-catalog',
            query: {
                'page': page,
                'size': size,
                'sortBy': sortBy,
                'sortDir': sortDir,
            },
        });
    }
    /**
     * Get the maximum price
     * Get the highest monthly price among the offers
     * @returns number OK
     * @throws ApiError
     */
    public static getMaxPrice({
        category,
    }: {
        /**
         * The car category to filter prices by
         */
        category: 'RENTAL' | 'USED' | 'VARIOUS',
    }): CancelablePromise<number> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/custom/car/maxPriceCatalog/{category}',
            path: {
                'category': category,
            },
        });
    }
    /**
     * Get a paginated list of all offers filtered by category
     * Retrieves a paginated list of all cars filtered by category to display in the catalog
     * @returns PageCarDTO OK
     * @throws ApiError
     */
    public static getAllFilteredOffers({
        category,
        page,
        size = 10,
        sortBy = 'brand',
        sortDir = 'asc',
    }: {
        /**
         * The car category to filter by
         */
        category: 'RENTAL' | 'USED' | 'VARIOUS',
        /**
         * The page number for pagination
         */
        page?: number,
        /**
         * The number of items page for pagination
         */
        size?: number,
        /**
         * The field to sort the results by
         */
        sortBy?: string,
        /**
         * The sorting direction
         */
        sortDir?: string,
    }): CancelablePromise<PageCarDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/custom/car/filtered-catalog/{category}',
            path: {
                'category': category,
            },
            query: {
                'page': page,
                'size': size,
                'sortBy': sortBy,
                'sortDir': sortDir,
            },
        });
    }
    /**
     * Get a paginated list of all offers with advanced filters
     * Retrieves a paginated list of all cars with advanced filtering options
     * @returns PageCarDTO OK
     * @throws ApiError
     */
    public static getAdvancedFilteredOffers({
        category,
        maxPrice,
        brand,
        doors,
        transmission,
        fuelType,
        page,
        size = 9,
        sortBy = 'brand',
        sortDir = 'asc',
    }: {
        /**
         * The car category to filter by (required)
         */
        category: 'RENTAL' | 'USED' | 'VARIOUS',
        /**
         * Maximum price per month
         */
        maxPrice?: number,
        /**
         * Car brand to filter by
         */
        brand?: string,
        /**
         * Number of doors
         */
        doors?: number,
        /**
         * Transmission type
         */
        transmission?: string,
        /**
         * Fuel type
         */
        fuelType?: string,
        /**
         * The page number for pagination
         */
        page?: number,
        /**
         * The number of items page for pagination
         */
        size?: number,
        /**
         * The field to sort the results by
         */
        sortBy?: string,
        /**
         * The sorting direction
         */
        sortDir?: string,
    }): CancelablePromise<PageCarDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/custom/car/advanced-filtered-catalog',
            query: {
                'category': category,
                'maxPrice': maxPrice,
                'brand': brand,
                'doors': doors,
                'transmission': transmission,
                'fuelType': fuelType,
                'page': page,
                'size': size,
                'sortBy': sortBy,
                'sortDir': sortDir,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static deleteCarOffer({
        id,
    }: {
        /**
         * The id of the car offer to delete
         */
        id: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/custom/car/deleteOffer/{id}',
            path: {
                'id': id,
            },
        });
    }
}
